import React, { useState } from 'react';
import '../styles/DealDisclosure.css';
import { renderHTML } from '../functions/rendering';

// Conspicuous, collapsible legal disclosure for the public buyer-facing pages
// (DealFeed + DealPresentation). The text is company-supplied markdown stored on
// the company doc (data.dealDisclaimer) and surfaced through the public API as
// company.dealDisclaimer — so this renders only for companies that set one.
//
// Progressive disclosure: an always-visible labeled header (conspicuous enough
// to be enforceable) that expands to the full terms (keeps the long legal text
// from dominating the page). Returns null when there's no disclaimer.
//
// `variant` tunes outer spacing per host page ('card' on the deal page, 'footer'
// on the feed). The rendered markdown body is styled self-contained in
// DealDisclosure.css so it looks right regardless of which page CSS is loaded.
// `companyName` (the public-facing company name) is appended to the header when
// present: "Important Disclosures from {companyName}".
export default function DealDisclosure({ text, companyName, variant = 'card' }) {
    const [open, setOpen] = useState(false);

    if (typeof text !== 'string' || !text.trim()) return null;

    const title = companyName && companyName.trim()
        ? `Important Disclosures from ${companyName.trim()}`
        : 'Important Disclosures';

    return (
        <div className={`deal-disclosure deal-disclosure-${variant}`}>
            <button
                type="button"
                className="deal-disclosure-toggle"
                onClick={() => setOpen(prev => !prev)}
                aria-expanded={open}
            >
                <span className="deal-disclosure-title">{title}</span>
                <svg
                    className={`deal-disclosure-chevron${open ? ' deal-disclosure-chevron-open' : ''}`}
                    width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    aria-hidden="true"
                >
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </button>
            {open && (
                <div
                    className="deal-disclosure-content"
                    dangerouslySetInnerHTML={{ __html: renderHTML(text) }}
                />
            )}
        </div>
    );
}
